import { useCallback, useEffect, useState } from 'react';
import { eventsApi } from '../../../api/eventsApi';
import { sessionsApi } from '../../../api/sessionsApi';

/** The event and all of its sessions; `saveEvent` writes changes and reloads the event. */
export function useEventDetail(eventId) {
  const [event, setEvent] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [loadingSessions, setLoadingSessions] = useState(true);

  const reloadEvent = useCallback(async () => {
    try {
      setEvent(await eventsApi.getById(eventId));
    } catch (e) {
      console.error('Failed to load event:', e);
    }
  }, [eventId]);

  useEffect(() => {
    reloadEvent();
  }, [reloadEvent]);

  useEffect(() => {
    let cancelled = false;
    setLoadingSessions(true);
    sessionsApi.listAllByEvent(eventId)
      .then((list) => !cancelled && setSessions(list))
      .catch((e) => {
        console.error('Failed to load sessions:', e);
        if (!cancelled) setSessions([]);
      })
      .finally(() => !cancelled && setLoadingSessions(false));
    return () => { cancelled = true; };
  }, [eventId]);

  const saveEvent = async (updateData) => {
    await eventsApi.update(eventId, updateData);
    await reloadEvent();
  };

  return { event, sessions, loadingSessions, reloadEvent, saveEvent };
}
